import { skuInfoColumns } from '../../constants/columns';
import { columnsProps, IFormatColumns } from '../interface';

export function formatColumns(columns: columnsProps[]): IFormatColumns {
  const result: IFormatColumns = {
    left: [],
    right: [],
    content: [],
  };
  if (Array.isArray(columns)) {
    columns.forEach((column, index) => {
      switch (column.fixed) {
        case 'left':
          result.left.push({ ...column, toolbarIndex: index });
          break;
        case 'right':
          result.right.push({ ...column, toolbarIndex: index });
          break;
        default:
          result.content.push({ ...column, toolbarIndex: index });
      }
    });
  }
  return result;
}

export function columnsToCopyColumns(columns: columnsProps[]): columnsProps[] {
  const copyColumns: columnsProps[] = [];
  const filterTypes: string[] = ['image', 'images', 'popoverList', 'select', 'routeLink', 'dataStatus', 'productInfo', 'productInfoList'];
  columns.forEach(item => {
    const { renderType, dataIndex, title, children, } = item;
    if (!dataIndex) return;
    if (Array.isArray(children) && children.length) {
      copyColumns.push(...columnsToCopyColumns(children));
      return;
    }
    if (Array.isArray(dataIndex)) {
      const labelArr = typeof title === 'string' ? title.split('/') : '';
      dataIndex.forEach((fieldName, index) => {
        if (!!labelArr[index]) {
          copyColumns.push({
            dataIndex: fieldName,
            title: labelArr[index],
          });
        }
      });
      return;
    }
    if (renderType) {
      if (filterTypes.includes(renderType)) return;
      if (renderType === 'skuInfoList') {
        copyColumns.push(...skuInfoColumns);
        return;
      }
      copyColumns.push(item);
    } else {
      copyColumns.push(item);
    }
  });
  return copyColumns;
}
